export default __webpack_public_path__ + "static/media/Facilities-CACS-10.084af6b8.jpg";